module.exports = __webpack_public_path__ + "img/空白（页码+动静态文字）.ad92b20b.png";